/// <reference path="../../../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class ContractInvoiceDirectiveController {
        public static $inject: string[] = [
            '$filter',
            '$dealerwareNotification',
            '$mobilityCompanyAuthentication'
        ];

        public contract: any;
        public availableAdjustments: any;
        public showAccounting: boolean;
        public currency: string = '';
        public symbol: string = '';

        constructor(public $filter: any,
                    public $dealerwareNotification: any,
                    public $auth: any) {
        }

        public get flatPaymentSections() : any {
            if (!this.contract.currentInvoice || !this.contract.currentInvoice.paymentSections) return undefined;

            return this.$filter('orderBy')(
                this.contract.currentInvoice.paymentSections.flatMap((section: any) => section.items),
                (item: any) => {
                    item.label = moment(item.label)
                        .tz(this.$auth.location.time_zone_name)
                        .format('MMM DD, YYYY h:mm A z');

                    return moment(item.label);
                }
            );
        }

        public get paymentSectionTotal() : number {
            if (!this.contract.currentInvoice || !this.contract.currentInvoice.paymentSections) return undefined;

            return this.flatPaymentSections.reduce((total: number, item: any) => {
                return item.payment_code ? total : total + item.total;
            }, 0);
        }

        public isDeclinedPayment(item: any) : boolean {
            return !!item.payment_code;
        }

        public hideEditButton(sectionKey: string) : boolean {
            return !this.showAccounting || sectionKey in { taxes: 1, security_deposit: 1 };
        }

        public adjustmentTypeFor(sectionKey: string) : any {
            if (!this.availableAdjustments) { return; }

            return this.availableAdjustments.find((adjustment: any) => {
                return adjustment.pricing_key === sectionKey
            });
        }

        public handleKeypress(e: any) : void {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        }

        public showDeclineTip() : void {
            this.$dealerwareNotification.alert('Tip', 'Update or add a new credit card in the upper right corner of this invoice.');
        }
    }

    getDealerwareWebComponentsModule().controller('ContractInvoiceDirectiveController', ContractInvoiceDirectiveController);

    export class ContractInvoiceDirective implements ng.IDirective {
        public restrict         : string    =   'E';
        public controller       : any       =   'ContractInvoiceDirectiveController';
        public controllerAs     : string    =   'ctrl';
        public bindToController : boolean   =   true;
        public replace          : boolean   =   false;
        public scope            : Object    =   {
            contract: '=',
            availableAdjustments: '=',
            showAccounting: '='
        };
        public transclude       : boolean   =   false;
        public templateUrl      : string    =   '/components/contract/pricing/invoice/contract_invoice_directive.html';
        public static $inject   : string[]  =   [];

        constructor() {}

        public link : ng.IDirectiveLinkFn = (
            scope   :   any,
            element :   ng.IAugmentedJQuery,
            attrs   :   ng.IAttributes,
            ctrls   :   any
        ) => {}
    }

    // register the directive
    getDealerwareWebComponentsModule().directive("dealerwareContractInvoice",() => new ContractInvoiceDirective());
 }
